<template>
  <div>
    <h2 style="text-align: center;margin-bottom:30px;">创建批次</h2>
    <div>
      <el-form :model="form" ref="form" label-width="120px">
        <ul class="error-messages" v-if="!isEmptyErrors">
          <li v-for="error in errors">{{error[0].message}}</li>
        </ul>
        <div class="form-item">
          <div style="width:25%">
            <div>
              <el-select style="width:100%;" v-model="form.brand_id" clearable filterable :filter-method="filterSearch"
                         class="input-width" placeholder="礼卡品牌">
                <el-option v-for="item in brandList" :key="item.id" :label="item.brand_name"
                           :value="item.id"></el-option>
              </el-select>
            </div>
            <div style="margin:10px 0;">
              <el-select style="width:100%" v-model="currency" placeholder="货币" clearable filterable>
                <el-option v-for="(c, index) in currencies" :key="index" :label="`${c.label}(${c.symbol})`"
                           :value="c.value"></el-option>
              </el-select>
            </div>
            <div>
              <el-date-picker style="width:100%" format="yyyy-MM-dd HH:mm:ss" v-model="purchase_time" type="datetime"
                              placeholder="购买时间">
              </el-date-picker>
            </div>
          </div>
          <div style="width:25%">
            <div>
              <el-select style="width:100%" v-model="form.source_id" placeholder="来源"
                         allow-create
                         filterable
              >
                <el-option v-for="(status, index) in sourceList" :key="index" :label="status.purchase_from"
                           :value="status.id"></el-option>
              </el-select>
            </div>
            <div style="margin:10px 0;">
              <el-input style="width:100%;" v-model="rate" placeholder="汇率"></el-input>
            </div>
            <div>
              <el-input type="textarea" v-model="form.description" :row="1" placeholder="描述"></el-input>
            </div>
          </div>
          <div style="width:46%">
            <div style="margin-bottom:10px;">
              <el-input type="textarea" v-model="copyCardText" :rows="5"
                        placeholder="请按“卡号 密码 面值”格式输入,如果没有密码，则按“卡号 面值”格式输入，每个卡之间回车换行"></el-input>
            </div>
            <div>
              <el-button type="default" @click="formatCard">自动识别</el-button>
            </div>
          </div>
        </div>
        <div style="margin:20px 0;">
          <div class="detail-table-head">
            <div v-for="c in cardColumns" :style="{width:c.width}">
              {{ c.name }}
            </div>
          </div>
          <div class="detail-table-body">
            <div v-for="l in form.gift_card_list" class="detail-table-row">
              <div v-for="c in cardColumns" :style="{width:c.width}">
                <template v-if="c.field=='currency'">
                  <el-select style="width:140px" v-model="l.currency" placeholder="货币">
                    <el-option v-for="(c, index) in currencies" :key="index" :label="`${c.label}(${c.symbol})`"
                               :value="c.value"></el-option>
                  </el-select>
                </template>
                <template v-else-if="c.field=='purchase_rate'">
                  <el-input v-model="l.purchase_rate" placeholder="汇率"></el-input>
                </template>
                <template v-else>
                  <p style="font-size: 16px;">{{ l[c.field] }}</p>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div style="margin:10px 0 20px;">
          <label>总支付金额:</label>
          <label>{{ total_money }}</label>
          <label>元</label>
        </div>
      </el-form>
    </div>
    <div>
      <el-button :loading="isSubmitting" class="block" type="info" @click="submitHandler('form')">提 交</el-button>
    </div>
  </div>
</template>

<script>
  import api from '../../../services/api.js'

  let _ = require('lodash')

  export default {
    name: 'AddCards',
    props: ['brandList', 'currencies', 'sourceList'],
    computed: {
      total_money() {
        let total = 0
        if (this.form.gift_card_list.length) {
          this.form.gift_card_list.forEach((g) => {
           let value=g.face_value.replace(/[^0-9.]/g,'');
            total += (+value) * ((+g.purchase_rate)||1)
          })
        }
        return this.roundToDecimalPlace(total, 2)
      }
    },
    data() {
      return {
        isSubmitting: false,
        isEmptyErrors: true,
        errors: null,
        currency: '',
        rate: '',
        purchase_rate: '',
        purchase_time: '',
        form: {
          brand_id: '',
          source_id: '',
          purchase_time: '',
          description: '',
          purchase_money: '',
          gift_card_list: [],
        },
        brandListOptions: [],
        cardColumns: [
          {name: '卡号', field: 'gift_card_number', width: '130px'},
          {name: '密码', field: 'gift_card_pin', width: '80px'},
          {name: '面值', field: 'face_value', width: '80px'},
          {name: '货币', field: 'currency', width: '80px'},
          {name: '汇率', field: 'purchase_rate', width: '80px'},
        ],
        copyCardText: ''
      }
    },
    async mounted() {

    },
    methods: {
      roundToDecimalPlace(number, decimalPlaces) {
        var factor = Math.pow(10, decimalPlaces);
        var tempNumber = number * factor;
        var roundedTempNumber = Math.round(tempNumber);
        return roundedTempNumber / factor;
      },
      formatCard() {
        if (this.copyCardText) {
          this.form.gift_card_list = []
          let arr = this.copyCardText.split('\n');
          arr.forEach((c) => {
            c = c.replace(/\s+/g, ' ')
            let cardInfo = c.split(' ')
            if (cardInfo.length == 3) {
              this.form.gift_card_list.push({
                gift_card_number: cardInfo[0],
                gift_card_pin: cardInfo[1],
                face_value: cardInfo[2],
                currency: this.currency,
                purchase_rate: this.rate
              })
            } else {
              this.form.gift_card_list.push({
                gift_card_number: cardInfo[0],
                gift_card_pin: '',
                face_value: cardInfo[1],
                currency: this.currency,
                purchase_rate: this.rate
              })
            }
          })
        }
      },
      filterSearch(queryString, cb) {
        this.brandListOptions = []
        let res = this.brandList.filter((i) => {
          return i.brand_name.indexOf(queryString) > -1
        })
        _.each(res, item => {
          this.brandListOptions.push({value: item.brand_name, id: item.id})
        })
        if (callback)
          callback()
      },
      async submitHandler() {
        this.isEmptyErrors = true
        this.errors = []
        if (!this.form.gift_card_list.length) {
          this.isEmptyErrors = false
          this.errors = {
            business_name: [
              {message: '请至少添加一张礼卡'}
            ]
          }
          return
        }
        this.form.purchase_time = this.$moment(this.purchase_time).format('YYYY-MM-DD HH:mm:ss')
        this.isSubmitting = true;
        this.form.purchase_money = this.total_money;
        this.form.purchase_rate = this.rate;
        let res = await api.addCardBatch(this, this.form);
        this.isSubmitting = false
        if (res.body.status == 'ok') {
          this.$emit('addCardPatch')
        }
      },
      async filterSearch(val) {
        this.orders = []
        let mers = [];
        if (val) {
          let query = {}
          query.keyword_type = 0
          query.keyword = val
          let res = await api.getSingleOrders(this, query)
          mers = res.body.result
        }

        mers.forEach(item => {
          this.orders.push({value: item.order_id, id: item.order_id})
        })
      },
      handleAutoSelect() {
        this.order = this.orders.find(i => i.order_id == this.order_id)
        this.exceptions = this.order.exception_list
      },
      handleClear() {
        this.orders = []
        this.exceptions = []
      },
      async createTicket(index) {
        this.$emit('updateMail', index)
      },
    }
  }
</script>

<style lang="scss" scoped>
  .form-item {
    display: flex;
    justify-content: space-between;
  }

  .detail-table-head {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #D7D7D7;
    padding-bottom: 10px;
  }

  .detail-table-body {
    max-height: 300px;
    overflow: auto;
  }

  .detail-table-row {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #D7D7D7;
    padding: 10px 0;
    align-items: center;

    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/orders/card/AddCards.vue